<template>
    <v-card light class="adder">
        <v-card-title>Добавить вопрос/ответ</v-card-title>
        <v-card-text>
            <v-select
                    label="Кто спросил"
                    :items="[{value: 0, text: 'Студент'},{value: 1, text: 'Преподаватель'}]"
                    v-model="person_type"
            >

            </v-select>

            <v-textarea
                    outlined
                    name="input-7-4"
                    label="Вопрос"
                    v-model="question"
            ></v-textarea>

            <v-textarea
                    outlined
                    name="input-7-4"
                    label="Ответ"
                    v-model="answer"
            ></v-textarea>

        </v-card-text>
        <v-card-actions>
            <div class="flex-md-grow-1"></div>
            <v-btn
                    color="#8a2be2"
                    text
                    @click="closer"
            >
                Отмена
            </v-btn>
            <v-btn
                    color="#8a2be2"
                    text
                    @click="submit"
            >
                Сохранить
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import {HTTP} from "../../axios";

    export default {
        props:[
            'closer'
        ],
        name: "FAQAdder",
        data(){
            return{
                person_type: 1,
                question: "",
                answer: ""
            }
        },
        methods:{
            submit(){
                if(this.question == ""){
                    alert("Введите вопрос!")
                    return false
                }
                if(this.answer == ""){
                    alert("Ввидите ответ!")
                    return false
                }

                var data = {
                    person_type: this.person_type,
                    question: this.question,
                    answer: this.answer,
                }
                HTTP
                    .post("FAQ", JSON.stringify(data), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                    .then(()=>{
                        this.closer()
                    })
            }
        }
    }
</script>

<style scoped>
    .adder{
        max-width: 500px;
        width: 650px;
    }
</style>